import InventoryStock from './InventoryStock'
import InventoryLocationPicker from './InventoryLocationPicker'
import ProductImage from './ProductImage'

// ProductImage is also used outside the process view, so it keeps its own prop
// shape and is adapted to the plugin contract here rather than the other way round.
const ProductImagePlugin = ({ block, line }) =>
    <ProductImage itemId={line?.[block.value ?? 'itemId']} size={block.size ?? 'md'} />

/**
 * Domain plugins for the process view.
 *
 * The view renders `{ type: 'plugin', plugin: '<name>' }` by looking the name up
 * here — it never imports one of these directly. That is the whole point: a
 * process that is not about warehouses declares no plugin, and nothing about
 * inventory reaches it. Adding a plugin for another domain means adding a file
 * and a line here, not editing the view.
 *
 * Every plugin receives the same props, and takes what it needs:
 *
 *   block       the config object it was declared as
 *   line        the current work item
 *   lineIndex   its index in the record's item array (the store path)
 *   linesField  the name of that array
 *   testId      `<view>.<section>.<block>`
 *   useStore    the page's form store
 *   result      the section's declared `query`, reduced to { rows, total,
 *               count, byKey } — absent when the section declares none
 *   itemId      the value the query was keyed on
 *   itemName    the item's display name, from the section's title block
 */
export const PLUGINS = {
    inventoryStock:          InventoryStock,
    inventoryLocationPicker: InventoryLocationPicker,
    productImage:            ProductImagePlugin,
}

export const pluginFor = (name) => PLUGINS[name]
